import React from "react";
import { useRequiredParams } from "../../utils/use-required-params";
import { useGetOrganizationDetailsApi } from "../../api/methods/use-get-organization-details-api";
import { PageLoader } from "../../components/page-loader";
import Markdown from "markdown-to-jsx";

export const GuidelinesPage: React.FC = () => {
  const { organizationId } = useRequiredParams<{ organizationId: string }>();

  const { data: organization, isLoading: isOrganizationLoading } =
    useGetOrganizationDetailsApi({
      organizationId: organizationId,
    });

  if (isOrganizationLoading) {
    return <PageLoader />;
  }

  if (!organization) {
    return <div className="p-6 text-center bg-background text-foreground">Organization not found</div>;
  }

  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto p-6 prose prose-slate dark:prose-invert max-w-4xl">
        <Markdown>{organization.attributes.guidelines}</Markdown>
      </div>
    </div>
  );
};
